import React, {useEffect} from "react";
import "./App.scss";
import Main from "./containers/Main";
import BlogAdminPage from "./pages/BlogAdminPage";
import CustomCursor from "./components/customCursor/CustomCursor";
import {StyleProvider} from "./contexts/StyleContext";
import {useLocalStorage} from "./hooks/useLocalStorage";

function App() {
  const [isDark, setIsDark] = useLocalStorage("isDark_v2", true);
  const isAdminRoute =
    typeof window !== "undefined" && window.location.pathname.indexOf("/admin") === 0;

  useEffect(() => {
    document.body.style.backgroundColor = isDark ? "#0a0a0f" : "#ffffff";
    document.body.classList.toggle("dark-mode", isDark);
  }, [isDark]);

  return (
    <StyleProvider
      value={{
        isDark,
        changeTheme: () => setIsDark(previousValue => !previousValue)
      }}
    >
      <div className="App">
        <CustomCursor isDark={isDark} />
        {isAdminRoute ? <BlogAdminPage /> : <Main />}
      </div>
    </StyleProvider>
  );
}

export default App;
